import { actionTypes, mutationTypes, getterTypes } from './types';
import _service from '../api';

const actions = {
  async [actionTypes.FETCH_APPLICATION]({ commit, getters }) {
    if (getters[getterTypes.GET_APPLICATION].length == 0) {
      const { data } = await _service.fetchApplication();
      if (data) {
        commit(mutationTypes.SET_APPLICATION, data);
      }
    }
  },
  async [actionTypes.FETCH_LOCATION]({ commit, getters }) {
    if (getters[getterTypes.GET_LOCATION].length == 0) {
      const { data } = await _service.fetchLocation();
      if (data) {
        commit(mutationTypes.SET_LOCATION, data);
      }
    }
  },
  async [actionTypes.FETCH_ROL]({ commit, getters }) {
    if (getters[getterTypes.GET_ROL].length == 0) {
      const { data } = await _service.fetchRol();
      if (data) {
        commit(mutationTypes.SET_ROL, data);
      }
    }
  },
  async [actionTypes.FETCH_RESULT]({ commit }, { filters }) {
    const { data } = await _service.fetchResult(filters);
    if (data) {
      commit(mutationTypes.SET_CURRENT_FILTER, filters);
      commit(mutationTypes.SET_RESULT, data);
    }
  },
  async [actionTypes.FETCH_MESSAGE_BY_ID](_, { id }) {
    const { data } = await _service.fetchMessageById(id);
    return data;
  },
  async [actionTypes.DELETE_MESSAGE](_, { id }) {
    const { data } = await _service.deleteMessage(id);
    return data;
  },
  async [actionTypes.SAVE_CHANGES](_, { formData, isEditMode }) {
    if (isEditMode) {
      return await _service.updateMessage(formData);
    } else {
      return await _service.saveMessage(formData);
    }
  },
};

export default actions;
